import { styled } from '@uhg-abyss/web/tools/styled';

export const Styles = styled('div', {
  '.widget': {
    '.abyss-card-root': {
      borderColor: 'var(--abyss-colors-gray4)',
      boxShadow: 'none',
      padding: 'var(--abyss-space-lg) var(--abyss-space-md)',
      position: 'relative',
    },
    '.widget-divider.abyss-divider-root': {
      backgroundColor: 'var(--abyss-colors-gray3)',
      marginBottom: 'var(--abyss-space-lg)',
      marginTop: 'var(--abyss-space-md)',
    },
    h6: {
      color: 'var(--abyss-colors-black) !important',
      marginBottom: 'var(--abyss-space-xs)',
    },
  },
});
